var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-simplemde"},[_c('textarea',{staticClass:"vue-simplemde-textarea",attrs:{"name":_vm.name},domProps:{"value":_vm.modelValue},on:{"input":function($event){return _vm.handleInput($event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }